<template>
    <div class="header">
        <el-tag v-for="item in List" :key="item.ccy" size="large" style="margin-right: 10px;">
            {{ item.ccy }} {{ Math.round(item.availBal * 10000) / 10000 }}
        </el-tag>
        <el-tooltip content="刷新余额" effect="light" placement="top">
            <el-button icon="Refresh" @click="getBalance()" :loading="loading" />
        </el-tooltip>
    </div>
</template>

<style scoped>
.header {
    margin: 10px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #3a3a3a;
}
</style>

<script setup>
import { ref, toRaw, onMounted } from "vue"
import { ElMessage } from 'element-plus'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'

const systemStore = useSystemStore()
const logStore = useLogStore()
const loading = ref(false)
const USDT = ref("")
const List = ref([])

onMounted(() => {
    getBalance()
})

const getBalance = async () => {
    loading.value = true
    try {
        let result = await systemStore.privateClient.getBalance()
        List.value = result[0].details
        loading.value = false
    } catch (error) {
        loading.value = false
        ElMessage.error('刷新失败' + error)
        logStore.addLog({
            title: '获取余额失败',
            level: 'error',
            message: error
        })
    }
}

</script>